<main class="flex-grow bg-slate-100 flex-1 p-4 layout-main-container zuper-scrollbar overflow-auto" >
    
    <div class="filter-container flex justify-between items-center mb-3">
        <div>
            <h2 class="text-xl font-semibold leading-7 text-gray-700 mb-4 mx-1.5">
                <i class="ti ti-git-branch mr-1 text-2xl"></i>
                <span>
                    {{'all.text' | translate}} {{'text.workflows' | translate}} ({{totalRecords}})
                </span>
            </h2>
        </div>


        <!-- <button
            (click)="importWorkflow()"
            class="ml-auto mr-2 flex items-center gap-x-1 rounded-md bg-white px-3 py-2 h-10 text-base font-semibold text-gray-600 shadow-sm hover:bg-gray-100 border focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600">
            <i class="ti ti-file-arrow-left text-lg mr-1"></i>      
            {{'text.import.workflow' | translate}}
        </button> -->

        <div class="flex">
            <button 
                type="button" 
                class="flex justify-between items-center text-gray-100 bg-blue-700 font-medium rounded-l-lg text-base px-3 py-2 h-10 btn-primary"
                (click)="openTemplates()"
                >
                {{'text.create.workflow' | translate}}
            </button>
            <span class="px-2 btn-primary rounded-r-lg flex items-center justify-center submenu-trigger" [brnMenuTriggerFor]="createMenu">
                <i class="ti ti-chevron-down text-lg"></i>
            </span>
            <ng-template #createMenu>
                <hlm-menu class="min-w-40">
                    <span hlmMenuItem class="text-base text-gray-700 cursor-pointer" (click)="importWorkflow()">
                        <i class="ti ti-file-arrow-left mr-2 text-xl"></i> {{'text.import.workflow' | translate}}
                    </span>
                </hlm-menu>
            </ng-template>
        </div>
       

    </div>
    <div class="workflow-parent-container zuper-scrollbar">
        <div class="p-4 bg-red-100 mb-3 rounded-xl" *ngIf="needsAttentionWorkflows?.length">
            <div class="flex justify-between w-full">
                <p class="text-red-700 mb-2 text-base font-medium">{{'text.needs_attention' | translate}} ({{needsAttentionTotalRecords}})</p>
                <span class="text-red-700 mb-2 text-base font-medium cursor-pointer" *ngIf="needsAttentionLimit === 3 && needsAttentionTotalRecords > 3" (click)="needsAttentionLimit = 10; getNeedsAttentionWorkflows()">{{"text.view_all" | translate}}</span>
            </div>
            <div class="grid grid-cols-3 gap-4">
                @for(workflow of needsAttentionWorkflows; track $index){
                    <a class="block border border-gray-100 rounded-lg cursor-pointer workflow-card min-h-[14rem] bg-white"
                        (click)="redirectToHistory(workflow?.workflow_details)"
                        >
                        <div class="p-4">
                            <div class="flex space-x-2 w-full justify-between">
                                <div class="flex w-full gap-2">
                                        @if (!workflow?.workflow_details?.meta_data?.total_nodes) {
                                            <div class="flex-1 min-w-0">
                                            <h4 [title]="workflow?.workflow_details?.workflow_name"  class="text-lg text-gray-700 break-all font-semibold mt-2 line-clamp-2">
                                            {{ workflow?.workflow_details?.workflow_name }}
                                            </h4>
                                            </div>
                                        }

                                        <app-node-icon
                                            *ngIf="workflow?.workflow_details?.meta_data?.total_nodes >= 1&&workflow?.workflow_details?.meta_data?.initial_nodes?.[0]?.data"
                                            [nodeData]="workflow?.workflow_details?.meta_data?.initial_nodes?.[0]?.data"
                                            [workflowName]="workflow?.workflow_details?.workflow_name"
                                        ></app-node-icon>

                                        <app-node-icon
                                            *ngIf="workflow?.workflow_details?.meta_data?.total_nodes >= 2&&workflow?.workflow_details?.meta_data?.initial_nodes?.[1]?.data"
                                            [nodeData]="workflow?.workflow_details?.meta_data?.initial_nodes?.[1]?.data"
                                            [workflowName]="workflow?.workflow_details?.workflow_name"
                                        ></app-node-icon>

                                        <app-node-icon
                                            *ngIf="workflow?.workflow_details?.meta_data?.total_nodes >= 3&&workflow?.workflow_details?.meta_data?.initial_nodes?.[2]?.data"
                                            [nodeData]="workflow?.workflow_details?.meta_data?.initial_nodes?.[2]?.data"
                                            [workflowName]="workflow?.workflow_details?.workflow_name"
                                        ></app-node-icon>

                                        <div
                                            class="digit-container bg-white text-gray-500"
                                            *ngIf="workflow?.workflow_details?.meta_data?.total_nodes && workflow?.workflow_details?.meta_data?.total_nodes - 3 > 0"
                                        >
                                            +{{ workflow?.workflow_details?.meta_data?.total_nodes - (((workflow?.workflow_details?.meta_data?.initial_nodes?.length || 0) > 3) ? 3 : (workflow?.workflow_details?.meta_data?.initial_nodes?.length || 0)) }}
                                        </div>
                                    </div>
                                <span [brnMenuTriggerFor]="needsAttentionMenu" class="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100" (click)="$event.preventDefault(); $event.stopPropagation()" >
                                    <i class="ti ti-dots-vertical text-lg"></i>
                                </span>
                                <ng-template #needsAttentionMenu>
                                    <hlm-menu class="min-w-40">
                                        <span hlmMenuItem class="text-base" (click)="acknowledgeNeedsAttention(workflow?.workflow_details)">
                                            <span class="mr-2">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-circle-check">
                                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                    <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                                                    <path d="M9 12l2 2l4 -4" />
                                                </svg>
                                            </span>
                                            {{'text.acknowledge' | translate}}
                                        </span>
                                    </hlm-menu>
                                </ng-template>
                            </div>
                            @if(workflow?.workflow_details?.meta_data?.total_nodes){
                            <h4 class="text-lg text-gray-700 truncate break-words font-semibold mt-2" [title]="workflow?.workflow_details?.workflow_name" >{{workflow?.workflow_details?.workflow_name}}</h4>
                            }
                            <p class="text-gray-400 mt-2 text-ellipsis overflow-hidden min-h-20 line-clamp-3 text-base">{{workflow?.workflow_details?.workflow_description}}</p>
                            <div class="flex justify-between action-container my-2" *ngIf="!!workflow?.remarks">
                                <span class="text-base font-medium flex items-start justify-center text-red-500">
                                    <i class="ti ti-alert-triangle mr-2 mt-1"></i> 
                                    <p>{{workflow?.remarks}}</p> 
                                </span>
                            </div>
                            <div class="flex justify-between action-container my-2" *ngIf="workflow?.occurrences?.length > 0">
                                <span class="text-base font-medium flex items-start justify-center text-red-500">
                                    <i class="ti ti-alert-triangle mr-2 mt-1"></i> 
                                    <p>{{workflow?.occurrences[0]?.reason}} <span *ngIf="workflow?.occurrences[0]?.percentage"> by {{workflow?.occurrences[0]?.percentage}}%</span></p> 
                                </span>
                            </div>
                        </div>
                    </a>
                }

            </div>
        </div>
        <div class="filter-container">
            <div class="flex justify-between space-x-2">
                <button hlmBtn id="sortDropDown" hlmBtn variant='outline' [brnMenuTriggerFor]="menu" class="text-gray-700 mr-3 bg-white text-base" type="button">{{'text.sort.by' | translate}} {{sort[filter['sort_by']]}} 
                    <svg class="w-2.5 h-2.5 ms-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 4 4 4-4"/>
                    </svg>
                </button>
                    
                <!--Sort Dropdown menu -->
                <ng-template #menu>
                    <hlm-menu class="min-w-48">
                        <hlm-menu-group>
                          <hlm-menu-label class="text-base">{{'text.sort' | translate}}</hlm-menu-label>
                
                          <button hlmMenuItemCheckbox [checked]="filter['sort_by'] === 'workflow_name'" (triggered)="sortByWorkflow('workflow_name')">
                            <hlm-menu-item-check />
                            <span class="text-base">{{'text.workflow_name' | translate}}</span>
                          </button>
                
                          <button hlmMenuItemCheckbox [checked]="filter['sort_by'] === 'created_at'" (triggered)="sortByWorkflow('created_at')">
                            <hlm-menu-item-check />
                            <span class="text-base">{{'created.at.text' | translate}}</span>
                          </button>
                        </hlm-menu-group>
                
                        <hlm-menu-separator />
                
                        <hlm-menu-group>
                            <hlm-menu-label class="text-base">{{'text.sort.by' | translate}}</hlm-menu-label>
                  
                            <button hlmMenuItemCheckbox [checked]="filter['sort'] === 'ASC'" (triggered)="sortWorkflow('ASC')">
                              <hlm-menu-item-check />
                              <span class="text-base">{{'dataPicker.sort.ascending' | translate}}</span>
                            </button>
                  
                            <button hlmMenuItemCheckbox [checked]="filter['sort'] === 'DESC'" (triggered)="sortWorkflow('DESC')">
                              <hlm-menu-item-check />
                              <span class="text-base">{{'dataPicker.sort.descending' | translate}}</span>
                            </button>
                          </hlm-menu-group>
                      </hlm-menu>
                </ng-template>
                <form class="field-container">   
                    <label for="default-search" class="mb-2 text-base font-medium text-gray-700 sr-only">{{'text.search' | translate}}</label>
                    <div class="relative bg-white rounded-full">
                        <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                            <svg class="w-3 h-3 text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"/>
                            </svg>
                        </div>
                        <input
                            id="default-search"
                            class="block w-80 p-2 leading-5 h-10 pl-8 pr-8 text-base text-gray-700 border border-gray-200 rounded-lg bg-white"
                            [(ngModel)]="keyword"
                            [ngModelOptions]="{standalone: true}"
                            (keyup.enter)="searchKeyword()"
                            placeholder="{{'text.search' | translate}} Workflows"
                            autocomplete="off"
                            required>
                        <i 
                            class="ti ti-x absolute right-2.5 top-2 bottom-3 text-base cursor-pointer" 
                            (click)="clearSearch()"
                            *ngIf="keyword"
                            ></i>
    
                    </div>
                </form>
            </div>
        </div>
    
        
        <!-- GRID -->
        @if(workflows?.length){
            <div class="workflow-main-container overflow-y-auto overflow-x-hidden zuper-scrollbar rounded-xl mt-2 p-2">
                
                <div class=" grid grid-cols-3 gap-4">    
                    @for(workflow of workflows; track $index){
                        <a class="block border border-gray-100 rounded-lg cursor-pointer workflow-card min-h-[14rem] bg-white hover:shadow-sm"  (click)="openWorkflow(workflow)">
                            <div class="p-4">
                                <div class="flex space-x-2 w-full justify-between">
                                    <div class="flex w-full gap-2">
                                        @if (!workflow?.meta_data?.total_nodes) {
                                            <div class="flex-1 min-w-0">
                                            <h4 [title]="workflow?.workflow_name" class="text-lg text-gray-700 break-all font-semibold mt-2 line-clamp-2">
                                            {{ workflow?.workflow_name }}
                                            </h4>
                                            </div>
                                        }

                                        <app-node-icon
                                            *ngIf="workflow?.meta_data?.total_nodes >= 1&&workflow?.meta_data?.initial_nodes?.[0]?.data"
                                            [nodeData]="workflow?.meta_data?.initial_nodes?.[0]?.data"
                                            [workflowName]="workflow?.workflow_name"
                                        ></app-node-icon>

                                        <app-node-icon
                                            *ngIf="workflow?.meta_data?.total_nodes >= 2&&workflow?.meta_data?.initial_nodes?.[1]?.data"
                                            [nodeData]="workflow?.meta_data?.initial_nodes?.[1]?.data"
                                            [workflowName]="workflow?.workflow_name"
                                        ></app-node-icon>

                                        <app-node-icon
                                            *ngIf="workflow?.meta_data?.total_nodes >= 3&&workflow?.meta_data?.initial_nodes?.[2]?.data"
                                            [nodeData]="workflow?.meta_data?.initial_nodes?.[2]?.data"
                                            [workflowName]="workflow?.workflow_name"
                                        ></app-node-icon>

                                        <div
                                            class="digit-container bg-white text-gray-500"
                                            *ngIf="workflow?.meta_data?.total_nodes && workflow?.meta_data?.total_nodes - 3 > 0"
                                        >
                                            +{{ workflow?.meta_data?.total_nodes - (((workflow?.meta_data?.initial_nodes?.length || 0) > 3) ? 3 : (workflow?.meta_data?.initial_nodes?.length || 0)) }}
                                        </div>
                                    </div>


                                    <span [brnMenuTriggerFor]="workflowMenu" class="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100" (click)="$event.preventDefault(); $event.stopPropagation()" >
                                        <i class="ti ti-dots-vertical text-lg"></i>
                                    </span>
                                    <ng-template #workflowMenu>
                                        <hlm-menu class="min-w-40">
                                            <span hlmMenuItem class="text-base" (click)="setActivation('active', $index, $event)" *ngIf="!workflow?.is_active" >
                                                <span class="mr-2">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-circle-check">
                                                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                        <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                                                        <path d="M9 12l2 2l4 -4" />
                                                    </svg>
                                                </span>
                                                {{'activate.text' | translate}}
                                            </span>
                                            <span hlmMenuItem class="text-base" (click)="setActivation('deactive', $index, $event)" *ngIf="workflow?.is_active" >
                                                <span class="mr-2">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-circle-minus">
                                                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                        <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                                                        <path d="M9 12l6 0" />
                                                      </svg> 
                                                </span>
                                                {{'deactivate' | translate}}
                                            </span>
                                            <span hlmMenuItem class="text-base" (click)="redirectToHistory(workflow)">
                                                <img [src]="'assets/images/svgs/clock-bolt.svg'" class="mr-2 w-4 h-4" alt=""> {{'text.label.execution_history' | translate}}
                                            </span>
                                            <span hlmMenuItem class="text-base" (click)="setActivation('delete', $index, $event)" [ngClass]="{'text-red-500': !workflow?.is_active, 'text-gray-400 pointer-events-none': workflow?.is_active}" [disabled]="workflow?.is_active" >
                                                <i class="ti ti-trash mr-2 text-xl"></i> {{'delete.text' | translate}}
                                            </span>
                                        </hlm-menu>
                                    </ng-template>
                                </div>
                                <!-- <img [ngSrc]="workflow?.workflow_icon" width="24" height="24" *ngIf="workflow?.workflow_icon" class="h-8 w-8" alt="" loading="lazy"> -->
                                 @if(workflow?.meta_data?.total_nodes){
                                    <h4 [title]="workflow?.workflow_name"  class="text-lg text-gray-700 break-words truncate font-semibold mt-2">{{workflow?.workflow_name}}</h4>
                                 }
                                
                                <p class="text-gray-400 mt-2 text-ellipsis overflow-hidden min-h-16 line-clamp-3 text-base">{{workflow?.workflow_description}}</p>
                                @if(!workflow?.is_active){
                                    <p class="text-base text-gray-400 mt-4 font-semibold active-status flex items-center">
                                        <span class="mr-1">
                                            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g filter="url(#filter0_d_3470_41340)">
                                                <rect x="3" y="2" width="18" height="18" rx="9" fill="#4F5E71"/>
                                                <rect x="2.8125" y="1.8125" width="18.375" height="18.375" rx="9.1875" stroke="#07405C" stroke-opacity="0.1" stroke-width="0.375"/>
                                                <path d="M9.9751 8.30078V13.7008" stroke="#DBE7F5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M14.0249 8.30078V13.7008" stroke="#DBE7F5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                </g>
                                                <defs>
                                                <filter id="filter0_d_3470_41340" x="0.375" y="0.875" width="23.25" height="23.25" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                                                <feOffset dy="1.5"/>
                                                <feGaussianBlur stdDeviation="1.125"/>
                                                <feColorMatrix type="matrix" values="0 0 0 0 0.027451 0 0 0 0 0.25098 0 0 0 0 0.360784 0 0 0 0.16 0"/>
                                                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3470_41340"/>
                                                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3470_41340" result="shape"/>
                                                </filter>
                                                </defs>
                                                </svg>
                                                                                            
                                        </span> {{'text.inactive' | translate}}
                                    </p>
                                }@else if(workflow?.last_execution_time){
                                    <p class="text-base text-gray-500 mt-4 font-semibold execution-time">{{'Last run' | translate}} {{getTimeAgo(workflow?.last_execution_time)}} {{"text.ago" | translate}}</p>
                                }
                                <div class="flex justify-between action-container">
                                    <span class="text-base text-gray-700 self-end">
                                        <!-- <label class="flex items-center" hlmLabel (click)="$event.stopPropagation();">
                                            <hlm-switch class="mr-2"  (click)="$event.stopPropagation();" [(ngModel)]="switchState[$index]" (change)="setActivation((workflow?.is_active) ? 'deactive' : 'active', $index, $event)"/>
                                            {{(workflow?.is_active) ? 'text.active' : 'text.inactive' | translate}}
                                        </label> -->
                                    </span>
                                </div>
                            </div>
                        </a>
                    }
                </div>
                <div class="w-full">
                    @if(!showLoader && workflows.length > 0){
                        <div class="text-center mt-2 text-gray-700 cursor-pointer" *ngIf="(totalRecords > workflows?.length)" (click)="loadWorkflows()">{{'text.load_more' | translate}}</div>
                    }@else if(workflows.length > 0){
                        <lazy-loader />
                    }
                </div>
            </div>
        }@else if(showLoader && workflows.length === 0){
            <div class="shimmer-container rounded-xl p-3 bg-slate-50 mt-2 grid grid-cols-3 gap-4 overflow-auto zuper-scrollbar">
                <app-card-skeleton *ngFor="let shimmer of shimmerArr"></app-card-skeleton>
            </div>
        }@else{
            <div class="no-result-container rounded-xl p-3 bg-slate-50 mt-2 flex justify-center items-center">
                <div class="flex justify-center flex-col items-center">
                    <img [src]="'assets/images/svgs/no_result_workflow.svg'" class="w-48 h-48" alt="" loading="lazy">
                    <h4 class="text-lg text-gray-500 font-semibold mt-2" *ngIf="filter['filter.keyword']">{{'text.no_result_found' | translate}} "{{filter['filter.keyword']}}"</h4>
                    <p class="text-base text-gray-400 mt-2" *ngIf="filter['filter.keyword']">{{'text.check_spelling_error' | translate}}</p>
                    <h4 class="text-lg text-gray-500 font-semibold mt-2" *ngIf="!filter['filter.keyword']">{{'text.no_workflows_created' | translate}}</h4>
                    <p class="text-base text-gray-400 mt-2" >{{'text.create_new_workflow_from_scratch' | translate}}</p>
                    <div class="flex mt-3 justify-center w-full" *ngIf="!filter['filter.keyword']">
                        <button 
                            type="button" 
                            hlmBtn
                            class="flex justify-between items-center text-gray-100 font-medium rounded-lg text-base px-3 py-2 h-10 btn-primary"
                            (click)="openTemplates()"
                            >
                            {{'text.new_workflow' | translate}}
                        </button>
                    </div>
                </div>
            </div>
        }
        <!-- END GRID -->
    </div>
    
</main>